import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { largeTitle as titleStyle } from '../styles/theme';
import renderNewlinesAsJsxBreaks from '../helpers/renderNewlinesAsJsxBreaks';
import TopicTitle from './TopicTitle';
import Title from './Title';

const Caption = ({
  children,
  classNames,
  classes,
  copy,
  title,
  titleTag,
  topicTitle,
  topicTitleTag,
  isOverlay,
}) => {
  const displayCopy = !isOverlay && copy;

  return (
    <div
      className={cn({
        [classNames.caption]: true,
        [classNames.overlayContainer]: isOverlay,
      })}
    >
      {topicTitle && (
        <TopicTitle className={classNames.topicTitle} tag={topicTitleTag}>
          {topicTitle}
        </TopicTitle>
      )}

      {title && (
        <Title
          className={cn({
            [classNames.overlayTitle]: isOverlay,
            [classNames.title]: !isOverlay,
            [classes.title]: !isOverlay,
          })}
          tag={titleTag}
        >
          {title}
        </Title>
      )}

      {displayCopy && (
        <p className={cn(classNames.copy, classes.copy)}>
          {renderNewlinesAsJsxBreaks(copy)}
        </p>
      )}

      {children}
    </div>
  );
};

Caption.propTypes = {
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  classNames: PropTypes.shape({
    caption: PropTypes.string,
    copy: PropTypes.string,
    title: PropTypes.string,
    topicTitle: PropTypes.string,
    overlayTitle: PropTypes.string,
    overlayContainer: PropTypes.string,
  }),
  copy: PropTypes.string,
  title: PropTypes.string,
  titleTag: PropTypes.string,
  topicTitle: PropTypes.string,
  topicTitleTag: PropTypes.string,
  isOverlay: PropTypes.bool,
};

Caption.defaultProps = {
  children: undefined,
  classNames: {},
  copy: undefined,
  title: undefined,
  titleTag: 'h2',
  topicTitle: undefined,
  topicTitleTag: 'h3',
  isOverlay: false,
};

export default injectSheet({
  title: {
    ...titleStyle,
    marginBottom: 3,
  },
  copy: {
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: 0.3,
    margin: [0, 0, '1.2em'],
    'div p&': {
      fontFamily: theme.fonts.body,
    },
  },
})(Caption);
